
import { useContext } from "react";

import { OPTIMIZATION_RATINGS } from "../../../../lib/config";

import { AnswerContext } from "../../../../state/answers";

export default function Score() {

  const { selectedAnswers, finalScore } = useContext( AnswerContext );

  const optimaztionRatingIndex = Math.floor( ( finalScore / 100 ) * 4.9 );

  const optimizationRating = OPTIMIZATION_RATINGS[ optimaztionRatingIndex ];

  const backgroundPosition = { backgroundPosition: `${finalScore}% 0%` };
  
  const ratingPosition = finalScore >= 50 ? { right: `${ Math.abs( finalScore - 100 ) }%` } : { left: `${ finalScore }%` };

  return (

    <div className="flex flex-col items-center w-full pb-8">

      <h2 className="font-bold text-7xl sm:text-9xl text-black">{ finalScore }</h2>

      <div className="flex text-sm sm:text-2xl pb-5 sm:pb-10">

        <p className="text-blue-primary">Your lab optimization rating is:</p>

        &nbsp;

        <span 

          className="font-bold bg-score-gradient bg-size-[10000%_100%] bg-clip-text text-transparent capitalize"

          style={ backgroundPosition }

        >

          { optimizationRating }

        </span>

      </div>

      <div className="bg-score-gradient h-5 rounded-full w-full flex items-center relative">

        <div 

          className="absolute h-9 sm:h-12 w-9 sm:w-12 rounded-full flex items-center justify-center outline-5 outline-white bg-score-gradient bg-size-[1000%_100%]"

          style={ { ...backgroundPosition, ...ratingPosition } }

        >

          <span className="font-bold text-white text-base sm:text-xl">{ finalScore }</span>

        </div>

      </div>

    </div>

  )

}
